import { ObjectValues } from "@/src/shared/types/objectValues";
import type {
  DSInlineTokenGroupEdge,
  DSInlineTokenVariant,
} from "@/src/design_system/data_display/inline_token/types/props";
import type { DSFlagName } from "@/src/design_system/primitives/flag/types/flagName";
import type { DSIconName } from "@/src/design_system/primitives/icon/types/iconName.generated";
import type {
  DSAffixProps,
  DSAriaLabelProps,
  DSFieldIdentityProps,
  DSInputAriaProps,
  DSInputBehaviorProps,
  DSStatefulProps,
} from "@/src/design_system/shared/types/props";

export const DS_TOKEN_INPUT_BACKSPACE = {
  Select: "select",
  Edit: "edit",
  Remove: "remove",
} as const;

export type DSTokenInputBackspace = ObjectValues<typeof DS_TOKEN_INPUT_BACKSPACE>;

export const DS_TOKEN_INPUT_EDIT_MODE = {
  Text: "text",
  Replace: "replace",
  None: "none",
} as const;

export type DSTokenInputEditMode = ObjectValues<typeof DS_TOKEN_INPUT_EDIT_MODE>;

export interface DSInputToken {
  id?: string;
  text: string;
  label?: string;
  variant?: DSInlineTokenVariant;
  group?: string;
  groupEdge?: DSInlineTokenGroupEdge;
  prefixIcon?: DSIconName;
  avatarUrl?: string;
  flag?: DSFlagName;
  description?: string;
  editMode?: DSTokenInputEditMode;
}

export type DSTokenInputProps = DSFieldIdentityProps &
  Omit<DSStatefulProps, "required"> &
  DSAffixProps &
  Pick<DSInputBehaviorProps, "placeholder" | "autocomplete" | "clearable"> &
  DSInputAriaProps &
  Pick<DSAriaLabelProps, "ariaLabel"> & {
    modelValue?: string;
    tokens?: DSInputToken[];
    caret?: number;
    backspace?: DSTokenInputBackspace;
    commitKeys?: string[];
    commitOnBlur?: boolean;
    serializedValue?: string;
    dataCySuffix?: string;
    hasError?: boolean;
  };
